
import Vue from 'vue'

const locales = {keys(){return []}}
global['____71DC0AE____'] = true;
delete global['____71DC0AE____'];
global.__uniConfig = {"globalStyle":{"navigationBarTextStyle":"black","navigationBarTitleText":"uni-app","navigationBarBackgroundColor":"#F8F8F8","backgroundColor":"#F8F8F8","pageOrientation":"auto","background":"#efeff4"}};
global.__uniConfig.compilerVersion = '4.76';
global.__uniConfig.darkmode = false;
global.__uniConfig.themeConfig = {};
global.__uniConfig.uniPlatform = 'h5';
global.__uniConfig.appId = '__UNI__71DC0AE';
global.__uniConfig.appName = '尚捷MES';
global.__uniConfig.appVersion = '1.0.3';
global.__uniConfig.appVersionCode = '103';
global.__uniConfig.router = {"mode":"hash","base":"/"};
global.__uniConfig.publicPath = "/";
global.__uniConfig['async'] = {"loading":"AsyncLoading","error":"AsyncError","delay":200,"timeout":60000};
global.__uniConfig.debug = false;
global.__uniConfig.networkTimeout = {"request":60000,"connectSocket":60000,"uploadFile":60000,"downloadFile":60000};
global.__uniConfig.sdkConfigs = {"maps":{"qqmap":{"key":"JZ3BZ-CM56X-ZOB4X-Z2N2A-XSL2S-DZFD4"}}};
global.__uniConfig.qqMapKey = "JZ3BZ-CM56X-ZOB4X-Z2N2A-XSL2S-DZFD4";
global.__uniConfig.googleMapKey = undefined;
global.__uniConfig.aMapKey = undefined;
global.__uniConfig.aMapSecurityJsCode = undefined;
global.__uniConfig.aMapServiceHost = undefined;
global.__uniConfig.locale = "";
global.__uniConfig.fallbackLocale = undefined;
global.__uniConfig.locales = locales.keys().reduce((res,key)=>{const locale=key.replace(/\.\/(uni-app.)?(.*).json/,'$2');const messages = locales(key);Object.assign(res[locale]||(res[locale]={}),messages.common||messages);return res},{});
global.__uniConfig.nvue = {"flex-direction":"column"}
global.__uniConfig.__webpack_chunk_load__ = __webpack_chunk_load__
Vue.component('pages-home-home', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("F:/dome/sj_ccapp/pages/home/home"+'.vue')), 'pages-home-home'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-mes-index-index', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("F:/dome/sj_ccapp/pages/mes/index/index"+'.vue')), 'pages-mes-index-index'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-mes-packagingReporting-packagingReporting', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("F:/dome/sj_ccapp/pages/mes/packagingReporting/packagingReporting"+'.vue')), 'pages-mes-packagingReporting-packagingReporting'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-mes-packagingReporting-detail-detail', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("F:/dome/sj_ccapp/pages/mes/packagingReporting/detail/detail"+'.vue')), 'pages-mes-packagingReporting-detail-detail'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-mes-packingReporting-packingReporting', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("F:/dome/sj_ccapp/pages/mes/packingReporting/packingReporting"+'.vue')), 'pages-mes-packingReporting-packingReporting'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-mes-packingReporting-detail-detail', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("F:/dome/sj_ccapp/pages/mes/packingReporting/detail/detail"+'.vue')), 'pages-mes-packingReporting-detail-detail'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-mes-receivingMaterials-receivingMaterials', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("F:/dome/sj_ccapp/pages/mes/receivingMaterials/receivingMaterials"+'.vue')), 'pages-mes-receivingMaterials-receivingMaterials'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-mes-receivingMaterials-receivingMaterialsDetailed-receivingMaterialsDetailed', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("F:/dome/sj_ccapp/pages/mes/receivingMaterials/receivingMaterialsDetailed/receivingMaterialsDetailed"+'.vue')), 'pages-mes-receivingMaterials-receivingMaterialsDetailed-receivingMaterialsDetailed'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-login-login', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("F:/dome/sj_ccapp/pages/login/login"+'.vue')), 'pages-login-login'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-mes-report-report', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("F:/dome/sj_ccapp/pages/mes/report/report"+'.vue')), 'pages-mes-report-report'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-print-print', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("F:/dome/sj_ccapp/pages/print/print"+'.vue')), 'pages-print-print'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-mes-index-detail-detail', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("F:/dome/sj_ccapp/pages/mes/index/detail/detail"+'.vue')), 'pages-mes-index-detail-detail'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-mes-wage-wage', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("F:/dome/sj_ccapp/pages/mes/wage/wage"+'.vue')), 'pages-mes-wage-wage'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-mes-wagedetails-wagedetails', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("F:/dome/sj_ccapp/pages/mes/wagedetails/wagedetails"+'.vue')), 'pages-mes-wagedetails-wagedetails'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-mes-scanReport-scanReport', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("F:/dome/sj_ccapp/pages/mes/scanReport/scanReport"+'.vue')), 'pages-mes-scanReport-scanReport'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-mes-handindex-handindex', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("F:/dome/sj_ccapp/pages/mes/handindex/handindex"+'.vue')), 'pages-mes-handindex-handindex'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-mes-handindex-handdetail-handdetail', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("F:/dome/sj_ccapp/pages/mes/handindex/handdetail/handdetail"+'.vue')), 'pages-mes-handindex-handdetail-handdetail'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-mes-scanPage-scanPage', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("F:/dome/sj_ccapp/pages/mes/scanPage/scanPage"+'.vue')), 'pages-mes-scanPage-scanPage'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-mes-wagedetails-stylewage-stylewage', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("F:/dome/sj_ccapp/pages/mes/wagedetails/stylewage/stylewage"+'.vue')), 'pages-mes-wagedetails-stylewage-stylewage'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-mes-scanPage-selectTicket-selectTicket', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("F:/dome/sj_ccapp/pages/mes/scanPage/selectTicket/selectTicket"+'.vue')), 'pages-mes-scanPage-selectTicket-selectTicket'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-mes-cuttingbed-cuttingbed', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("F:/dome/sj_ccapp/pages/mes/cuttingbed/cuttingbed"+'.vue')), 'pages-mes-cuttingbed-cuttingbed'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-mes-cuttingbed-reportdetails-reportdetails', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("F:/dome/sj_ccapp/pages/mes/cuttingbed/reportdetails/reportdetails"+'.vue')), 'pages-mes-cuttingbed-reportdetails-reportdetails'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-mes-packingList-packingList', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("F:/dome/sj_ccapp/pages/mes/packingList/packingList"+'.vue')), 'pages-mes-packingList-packingList'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-mes-packingList-packingListDetail-packingListDetail', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("F:/dome/sj_ccapp/pages/mes/packingList/packingListDetail/packingListDetail"+'.vue')), 'pages-mes-packingList-packingListDetail-packingListDetail'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-mes-report-reportDelect-reportDelect', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("F:/dome/sj_ccapp/pages/mes/report/reportDelect/reportDelect"+'.vue')), 'pages-mes-report-reportDelect-reportDelect'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-mes-wagedetails-stylewage-processwage-processwage', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("F:/dome/sj_ccapp/pages/mes/wagedetails/stylewage/processwage/processwage"+'.vue')), 'pages-mes-wagedetails-stylewage-processwage-processwage'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-base-supplier-supplier', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("F:/dome/sj_ccapp/pages/base/supplier/supplier"+'.vue')), 'pages-base-supplier-supplier'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-base-supplier-supplierDetails-supplierDetails', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("F:/dome/sj_ccapp/pages/base/supplier/supplierDetails/supplierDetails"+'.vue')), 'pages-base-supplier-supplierDetails-supplierDetails'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-base-clientele-clientele', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("F:/dome/sj_ccapp/pages/base/clientele/clientele"+'.vue')), 'pages-base-clientele-clientele'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-base-clientele-clienteleDetails-clienteleDetails', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("F:/dome/sj_ccapp/pages/base/clientele/clienteleDetails/clienteleDetails"+'.vue')), 'pages-base-clientele-clienteleDetails-clienteleDetails'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-mes-outsource-outsourceDetail-outsourceDetail', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("F:/dome/sj_ccapp/pages/mes/outsource/outsourceDetail/outsourceDetail"+'.vue')), 'pages-mes-outsource-outsourceDetail-outsourceDetail'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-mes-outsource-outsource', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("F:/dome/sj_ccapp/pages/mes/outsource/outsource"+'.vue')), 'pages-mes-outsource-outsource'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-mes-addOutsource-addOutsource', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("F:/dome/sj_ccapp/pages/mes/addOutsource/addOutsource"+'.vue')), 'pages-mes-addOutsource-addOutsource'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-mes-addOutsource-selsectOrder-selsectOrder', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("F:/dome/sj_ccapp/pages/mes/addOutsource/selsectOrder/selsectOrder"+'.vue')), 'pages-mes-addOutsource-selsectOrder-selsectOrder'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-mes-qualityRestriction-qualityRestriction', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("F:/dome/sj_ccapp/pages/mes/qualityRestriction/qualityRestriction"+'.vue')), 'pages-mes-qualityRestriction-qualityRestriction'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-mes-qualityRestriction-qualityDetails-qualityDetails', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("F:/dome/sj_ccapp/pages/mes/qualityRestriction/qualityDetails/qualityDetails"+'.vue')), 'pages-mes-qualityRestriction-qualityDetails-qualityDetails'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-mes-qualityRestriction-checkProgress-checkProgress', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("F:/dome/sj_ccapp/pages/mes/qualityRestriction/checkProgress/checkProgress"+'.vue')), 'pages-mes-qualityRestriction-checkProgress-checkProgress'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-mes-qualityRestriction-goCheck-goCheck', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("F:/dome/sj_ccapp/pages/mes/qualityRestriction/goCheck/goCheck"+'.vue')), 'pages-mes-qualityRestriction-goCheck-goCheck'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-mes-qualityRestriction-qualityReport-qualityReport', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("F:/dome/sj_ccapp/pages/mes/qualityRestriction/qualityReport/qualityReport"+'.vue')), 'pages-mes-qualityRestriction-qualityReport-qualityReport'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-base-mapDepot-mapDepot', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("F:/dome/sj_ccapp/pages/base/mapDepot/mapDepot"+'.vue')), 'pages-base-mapDepot-mapDepot'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-base-mapDepot-mapDepotDetails-mapDepotDetails', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("F:/dome/sj_ccapp/pages/base/mapDepot/mapDepotDetails/mapDepotDetails"+'.vue')), 'pages-base-mapDepot-mapDepotDetails-mapDepotDetails'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-pdm-index-index', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("F:/dome/sj_ccapp/pages/pdm/index/index"+'.vue')), 'pages-pdm-index-index'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-mes-pullCloth-pullCloth', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("F:/dome/sj_ccapp/pages/mes/pullCloth/pullCloth"+'.vue')), 'pages-mes-pullCloth-pullCloth'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-mes-pullCloth-addPullcloth-addPullcloth', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("F:/dome/sj_ccapp/pages/mes/pullCloth/addPullcloth/addPullcloth"+'.vue')), 'pages-mes-pullCloth-addPullcloth-addPullcloth'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-mes-pullCloth-selsectCloth-selsectCloth', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("F:/dome/sj_ccapp/pages/mes/pullCloth/selsectCloth/selsectCloth"+'.vue')), 'pages-mes-pullCloth-selsectCloth-selsectCloth'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-mes-loosenCloth-loosenCloth', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("F:/dome/sj_ccapp/pages/mes/loosenCloth/loosenCloth"+'.vue')), 'pages-mes-loosenCloth-loosenCloth'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-mes-loosenCloth-addLoosencloth-addLoosencloth', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("F:/dome/sj_ccapp/pages/mes/loosenCloth/addLoosencloth/addLoosencloth"+'.vue')), 'pages-mes-loosenCloth-addLoosencloth-addLoosencloth'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-mes-loosenCloth-loosenClothWidth-loosenClothWidth', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("F:/dome/sj_ccapp/pages/mes/loosenCloth/loosenClothWidth/loosenClothWidth"+'.vue')), 'pages-mes-loosenCloth-loosenClothWidth-loosenClothWidth'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-mes-materialRequisition-materialRequisition', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("F:/dome/sj_ccapp/pages/mes/materialRequisition/materialRequisition"+'.vue')), 'pages-mes-materialRequisition-materialRequisition'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-mes-materialRequisition-addMaterialRequisition-addMaterialRequisition', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("F:/dome/sj_ccapp/pages/mes/materialRequisition/addMaterialRequisition/addMaterialRequisition"+'.vue')), 'pages-mes-materialRequisition-addMaterialRequisition-addMaterialRequisition'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-mes-materialRequisition-importMaterialNeed-importMaterialNeed', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("F:/dome/sj_ccapp/pages/mes/materialRequisition/importMaterialNeed/importMaterialNeed"+'.vue')), 'pages-mes-materialRequisition-importMaterialNeed-importMaterialNeed'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-mes-loosenCloth-importClothNeed-importClothNeed', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("F:/dome/sj_ccapp/pages/mes/loosenCloth/importClothNeed/importClothNeed"+'.vue')), 'pages-mes-loosenCloth-importClothNeed-importClothNeed'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-mes-QC-QC', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("F:/dome/sj_ccapp/pages/mes/QC/QC"+'.vue')), 'pages-mes-QC-QC'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-mes-QC-QCdetails-QCdetails', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("F:/dome/sj_ccapp/pages/mes/QC/QCdetails/QCdetails"+'.vue')), 'pages-mes-QC-QCdetails-QCdetails'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-mes-warehouse-comeWarehouse-comeWarehouse', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("F:/dome/sj_ccapp/pages/mes/warehouse/comeWarehouse/comeWarehouse"+'.vue')), 'pages-mes-warehouse-comeWarehouse-comeWarehouse'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-mes-warehouse-outWarehouse-outWarehouse', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("F:/dome/sj_ccapp/pages/mes/warehouse/outWarehouse/outWarehouse"+'.vue')), 'pages-mes-warehouse-outWarehouse-outWarehouse'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-mes-progressPage-progressPage', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("F:/dome/sj_ccapp/pages/mes/progressPage/progressPage"+'.vue')), 'pages-mes-progressPage-progressPage'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-mes-progressPage-progressDetails-progressDetails', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("F:/dome/sj_ccapp/pages/mes/progressPage/progressDetails/progressDetails"+'.vue')), 'pages-mes-progressPage-progressDetails-progressDetails'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-mes-progressPage-progressList-progressList', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("F:/dome/sj_ccapp/pages/mes/progressPage/progressList/progressList"+'.vue')), 'pages-mes-progressPage-progressList-progressList'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-pdm-auditList-auditList', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("F:/dome/sj_ccapp/pages/pdm/auditList/auditList"+'.vue')), 'pages-pdm-auditList-auditList'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-pdm-sampleManagement-sampleList-sampleList', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("F:/dome/sj_ccapp/pages/pdm/sampleManagement/sampleList/sampleList"+'.vue')), 'pages-pdm-sampleManagement-sampleList-sampleList'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-pdm-sampleManagement-sampleSale-sampleSale', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("F:/dome/sj_ccapp/pages/pdm/sampleManagement/sampleSale/sampleSale"+'.vue')), 'pages-pdm-sampleManagement-sampleSale-sampleSale'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-pdm-sampleManagement-sampleInventory-sampleInventory', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("F:/dome/sj_ccapp/pages/pdm/sampleManagement/sampleInventory/sampleInventory"+'.vue')), 'pages-pdm-sampleManagement-sampleInventory-sampleInventory'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-pdm-sampleManagement-sampleBorrow-sampleBorrow', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("F:/dome/sj_ccapp/pages/pdm/sampleManagement/sampleBorrow/sampleBorrow"+'.vue')), 'pages-pdm-sampleManagement-sampleBorrow-sampleBorrow'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-pdm-sampleManagement-sampleAlso-sampleAlso', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("F:/dome/sj_ccapp/pages/pdm/sampleManagement/sampleAlso/sampleAlso"+'.vue')), 'pages-pdm-sampleManagement-sampleAlso-sampleAlso'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-scm-fullLifeCircle-fullLifeCircle', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("F:/dome/sj_ccapp/pages/scm/fullLifeCircle/fullLifeCircle"+'.vue')), 'pages-scm-fullLifeCircle-fullLifeCircle'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-scm-fullLifeCircle-fullLifeCircleDetails-fullLifeCircleDetails', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("F:/dome/sj_ccapp/pages/scm/fullLifeCircle/fullLifeCircleDetails/fullLifeCircleDetails"+'.vue')), 'pages-scm-fullLifeCircle-fullLifeCircleDetails-fullLifeCircleDetails'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-scm-fullLifeCircle-fullLifeCircleDetails-components-cutNumberReport', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("F:/dome/sj_ccapp/pages/scm/fullLifeCircle/fullLifeCircleDetails/components/cutNumberReport"+'.vue')), 'pages-scm-fullLifeCircle-fullLifeCircleDetails-components-cutNumberReport'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-scm-fullLifeCircle-fullLifeCircleDetails-components-editFullLifeCircleDetails', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("F:/dome/sj_ccapp/pages/scm/fullLifeCircle/fullLifeCircleDetails/components/editFullLifeCircleDetails"+'.vue')), 'pages-scm-fullLifeCircle-fullLifeCircleDetails-components-editFullLifeCircleDetails'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-wms-purchase-purchaseList', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("F:/dome/sj_ccapp/pages/wms/purchase/purchaseList"+'.vue')), 'pages-wms-purchase-purchaseList'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-wms-purchase-addPurchase', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("F:/dome/sj_ccapp/pages/wms/purchase/addPurchase"+'.vue')), 'pages-wms-purchase-addPurchase'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-wms-components-addMaterial', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("F:/dome/sj_ccapp/pages/wms/components/addMaterial"+'.vue')), 'pages-wms-components-addMaterial'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-wms-purchase-editPurchaseMaterial', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("F:/dome/sj_ccapp/pages/wms/purchase/editPurchaseMaterial"+'.vue')), 'pages-wms-purchase-editPurchaseMaterial'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-wms-purchase-purchaseDetails', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("F:/dome/sj_ccapp/pages/wms/purchase/purchaseDetails"+'.vue')), 'pages-wms-purchase-purchaseDetails'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-wms-purchase-purchaseMaterialDetails', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("F:/dome/sj_ccapp/pages/wms/purchase/purchaseMaterialDetails"+'.vue')), 'pages-wms-purchase-purchaseMaterialDetails'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-wms-mergePurchase-mergePurchaseList', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("F:/dome/sj_ccapp/pages/wms/mergePurchase/mergePurchaseList"+'.vue')), 'pages-wms-mergePurchase-mergePurchaseList'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-wms-mergePurchase-mergePurchase', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("F:/dome/sj_ccapp/pages/wms/mergePurchase/mergePurchase"+'.vue')), 'pages-wms-mergePurchase-mergePurchase'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-wms-components-editSupplier', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("F:/dome/sj_ccapp/pages/wms/components/editSupplier"+'.vue')), 'pages-wms-components-editSupplier'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-wms-purorder-purorderList', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("F:/dome/sj_ccapp/pages/wms/purorder/purorderList"+'.vue')), 'pages-wms-purorder-purorderList'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-wms-purorder-addPurorder', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("F:/dome/sj_ccapp/pages/wms/purorder/addPurorder"+'.vue')), 'pages-wms-purorder-addPurorder'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-wms-purorder-purorderDetails', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("F:/dome/sj_ccapp/pages/wms/purorder/purorderDetails"+'.vue')), 'pages-wms-purorder-purorderDetails'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-wms-purorder-editPurorderDetails', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("F:/dome/sj_ccapp/pages/wms/purorder/editPurorderDetails"+'.vue')), 'pages-wms-purorder-editPurorderDetails'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-wms-purorder-purorderMaterialDetails', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("F:/dome/sj_ccapp/pages/wms/purorder/purorderMaterialDetails"+'.vue')), 'pages-wms-purorder-purorderMaterialDetails'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-wms-orderDeliverySchedule-orderDeliveryScheduleList', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("F:/dome/sj_ccapp/pages/wms/orderDeliverySchedule/orderDeliveryScheduleList"+'.vue')), 'pages-wms-orderDeliverySchedule-orderDeliveryScheduleList'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-wms-orderDeliverySchedule-components-purchasingList', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("F:/dome/sj_ccapp/pages/wms/orderDeliverySchedule/components/purchasingList"+'.vue')), 'pages-wms-orderDeliverySchedule-components-purchasingList'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-wms-orderDeliverySchedule-addOrderDeliverySchedule', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("F:/dome/sj_ccapp/pages/wms/orderDeliverySchedule/addOrderDeliverySchedule"+'.vue')), 'pages-wms-orderDeliverySchedule-addOrderDeliverySchedule'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-wms-orderDeliverySchedule-orderDeliveryScheduleDetails', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("F:/dome/sj_ccapp/pages/wms/orderDeliverySchedule/orderDeliveryScheduleDetails"+'.vue')), 'pages-wms-orderDeliverySchedule-orderDeliveryScheduleDetails'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-wms-orderDeliverySchedule-orderDeliveryScheduleMaterialDetails', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("F:/dome/sj_ccapp/pages/wms/orderDeliverySchedule/orderDeliveryScheduleMaterialDetails"+'.vue')), 'pages-wms-orderDeliverySchedule-orderDeliveryScheduleMaterialDetails'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-wms-orderDeliverySchedule-editOrderDeliveryScheduleMaterialDetails', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("F:/dome/sj_ccapp/pages/wms/orderDeliverySchedule/editOrderDeliveryScheduleMaterialDetails"+'.vue')), 'pages-wms-orderDeliverySchedule-editOrderDeliveryScheduleMaterialDetails'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-wms-iqc-checkList-finishProduct', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("F:/dome/sj_ccapp/pages/wms/iqc/checkList/finishProduct"+'.vue')), 'pages-wms-iqc-checkList-finishProduct'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-wms-iqc-checkList-finishProductDetail', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("F:/dome/sj_ccapp/pages/wms/iqc/checkList/finishProductDetail"+'.vue')), 'pages-wms-iqc-checkList-finishProductDetail'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-wms-iqc-checkList-material', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("F:/dome/sj_ccapp/pages/wms/iqc/checkList/material"+'.vue')), 'pages-wms-iqc-checkList-material'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-wms-iqc-checkList-materialDetail', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("F:/dome/sj_ccapp/pages/wms/iqc/checkList/materialDetail"+'.vue')), 'pages-wms-iqc-checkList-materialDetail'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-mes-packing-packing-packing', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("F:/dome/sj_ccapp/pages/mes/packing/packing/packing"+'.vue')), 'pages-mes-packing-packing-packing'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-mes-packing-packingDetails-packingDetails', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("F:/dome/sj_ccapp/pages/mes/packing/packingDetails/packingDetails"+'.vue')), 'pages-mes-packing-packingDetails-packingDetails'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-mes-braCupPacking-braCupPackingList', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("F:/dome/sj_ccapp/pages/mes/braCupPacking/braCupPackingList"+'.vue')), 'pages-mes-braCupPacking-braCupPackingList'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-mes-braCupPacking-braCupPackingDetail', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("F:/dome/sj_ccapp/pages/mes/braCupPacking/braCupPackingDetail"+'.vue')), 'pages-mes-braCupPacking-braCupPackingDetail'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-check-checkList-checkList', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("F:/dome/sj_ccapp/pages/check/checkList/checkList"+'.vue')), 'pages-check-checkList-checkList'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-check-checkList-paymentCheck-paymentCheck', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("F:/dome/sj_ccapp/pages/check/checkList/paymentCheck/paymentCheck"+'.vue')), 'pages-check-checkList-paymentCheck-paymentCheck'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-check-checkList-paymentCheck-otherPayableOrder', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("F:/dome/sj_ccapp/pages/check/checkList/paymentCheck/otherPayableOrder"+'.vue')), 'pages-check-checkList-paymentCheck-otherPayableOrder'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-check-checkList-outsourceCheck-outsourceCheck', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("F:/dome/sj_ccapp/pages/check/checkList/outsourceCheck/outsourceCheck"+'.vue')), 'pages-check-checkList-outsourceCheck-outsourceCheck'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-check-checkList-pricingCheck-pricingCheck', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("F:/dome/sj_ccapp/pages/check/checkList/pricingCheck/pricingCheck"+'.vue')), 'pages-check-checkList-pricingCheck-pricingCheck'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-check-checkList-clientCheck-clientCheck', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("F:/dome/sj_ccapp/pages/check/checkList/clientCheck/clientCheck"+'.vue')), 'pages-check-checkList-clientCheck-clientCheck'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-check-checkList-supplierCheck-supplierCheck', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("F:/dome/sj_ccapp/pages/check/checkList/supplierCheck/supplierCheck"+'.vue')), 'pages-check-checkList-supplierCheck-supplierCheck'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-check-checkList-purchaseCheck-purchaseCheck', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("F:/dome/sj_ccapp/pages/check/checkList/purchaseCheck/purchaseCheck"+'.vue')), 'pages-check-checkList-purchaseCheck-purchaseCheck'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-check-checkList-prepayCheck-prepayCheck', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("F:/dome/sj_ccapp/pages/check/checkList/prepayCheck/prepayCheck"+'.vue')), 'pages-check-checkList-prepayCheck-prepayCheck'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-check-checkList-prepayCheck-prepayDetail', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("F:/dome/sj_ccapp/pages/check/checkList/prepayCheck/prepayDetail"+'.vue')), 'pages-check-checkList-prepayCheck-prepayDetail'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-mes-groupCheck-groupCheck', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("F:/dome/sj_ccapp/pages/mes/groupCheck/groupCheck"+'.vue')), 'pages-mes-groupCheck-groupCheck'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-mes-endCheck-endCheck', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("F:/dome/sj_ccapp/pages/mes/endCheck/endCheck"+'.vue')), 'pages-mes-endCheck-endCheck'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
global.__uniRoutes=[
{
path: '/',
alias:'/pages/home/home',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          isQuit:true,
isEntry:true,

          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"工作台","navigationStyle":"custom","titleNView":false})
      },
      [
        createElement('pages-home-home', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
id:1,
  name:'pages-home-home',
  isNVue:false,maxWidth:0,
  pagePath:'pages/home/home',
isQuit:true,
isEntry:true,
  windowTop:0
}
},
{
path: '/pages/mes/index/index',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"制单管理","enablePullDownRefresh":true,"navigationStyle":"custom","titleNView":false})
      },
      [
        createElement('pages-mes-index-index', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-mes-index-index',
  isNVue:false,maxWidth:0,
  pagePath:'pages/mes/index/index',
  windowTop:0
}
},
{
path: '/pages/mes/packagingReporting/packagingReporting',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"包装报工","enablePullDownRefresh":true,"navigationStyle":"custom","titleNView":false})
      },
      [
        createElement('pages-mes-packagingReporting-packagingReporting', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-mes-packagingReporting-packagingReporting',
  isNVue:false,maxWidth:0,
  pagePath:'pages/mes/packagingReporting/packagingReporting',
  windowTop:0
}
},
{
path: '/pages/mes/packagingReporting/detail/detail',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"包装报工详情页-包装工单","enablePullDownRefresh":false,"navigationStyle":"custom","titleNView":false})
      },
      [
        createElement('pages-mes-packagingReporting-detail-detail', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-mes-packagingReporting-detail-detail',
  isNVue:false,maxWidth:0,
  pagePath:'pages/mes/packagingReporting/detail/detail',
  windowTop:0
}
},
{
path: '/pages/mes/packingReporting/packingReporting',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"装箱报工","enablePullDownRefresh":true,"navigationStyle":"custom","titleNView":false})
      },
      [
        createElement('pages-mes-packingReporting-packingReporting', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-mes-packingReporting-packingReporting',
  isNVue:false,maxWidth:0,
  pagePath:'pages/mes/packingReporting/packingReporting',
  windowTop:0
}
},
{
path: '/pages/mes/packingReporting/detail/detail',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"装箱报工详情页","enablePullDownRefresh":false,"navigationStyle":"custom","titleNView":false})
      },
      [
        createElement('pages-mes-packingReporting-detail-detail', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-mes-packingReporting-detail-detail',
  isNVue:false,maxWidth:0,
  pagePath:'pages/mes/packingReporting/detail/detail',
  windowTop:0
}
},
{
path: '/pages/mes/receivingMaterials/receivingMaterials',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"收料","enablePullDownRefresh":true,"navigationStyle":"custom","titleNView":false})
      },
      [
        createElement('pages-mes-receivingMaterials-receivingMaterials', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-mes-receivingMaterials-receivingMaterials',
  isNVue:false,maxWidth:0,
  pagePath:'pages/mes/receivingMaterials/receivingMaterials',
  windowTop:0
}
},
{
path: '/pages/mes/receivingMaterials/receivingMaterialsDetailed/receivingMaterialsDetailed',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"收料详情","enablePullDownRefresh":true,"navigationStyle":"custom","titleNView":false})
      },
      [
        createElement('pages-mes-receivingMaterials-receivingMaterialsDetailed-receivingMaterialsDetailed', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-mes-receivingMaterials-receivingMaterialsDetailed-receivingMaterialsDetailed',
  isNVue:false,maxWidth:0,
  pagePath:'pages/mes/receivingMaterials/receivingMaterialsDetailed/receivingMaterialsDetailed',
  windowTop:0
}
},
{
path: '/pages/login/login',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"登录页","enablePullDownRefresh":false,"navigationStyle":"custom","titleNView":false})
      },
      [
        createElement('pages-login-login', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-login-login',
  isNVue:false,maxWidth:0,
  pagePath:'pages/login/login',
  windowTop:0
}
},
{
path: '/pages/mes/report/report',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"汇报记录","enablePullDownRefresh":true,"navigationStyle":"custom","titleNView":false})
      },
      [
        createElement('pages-mes-report-report', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-mes-report-report',
  isNVue:false,maxWidth:0,
  pagePath:'pages/mes/report/report',
  windowTop:0
}
},
{
path: '/pages/print/print',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"打印","enablePullDownRefresh":false,"navigationStyle":"custom","titleNView":false})
      },
      [
        createElement('pages-print-print', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-print-print',
  isNVue:false,maxWidth:0,
  pagePath:'pages/print/print',
  windowTop:0
}
},
{
path: '/pages/mes/index/detail/detail',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"进度","enablePullDownRefresh":false,"navigationStyle":"custom","titleNView":false})
      },
      [
        createElement('pages-mes-index-detail-detail', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-mes-index-detail-detail',
  isNVue:false,maxWidth:0,
  pagePath:'pages/mes/index/detail/detail',
  windowTop:0
}
},
{
path: '/pages/mes/wage/wage',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"每日工资","enablePullDownRefresh":false,"navigationStyle":"custom","titleNView":false})
      },
      [
        createElement('pages-mes-wage-wage', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-mes-wage-wage',
  isNVue:false,maxWidth:0,
  pagePath:'pages/mes/wage/wage',
  windowTop:0
}
},
{
path: '/pages/mes/wagedetails/wagedetails',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"工资详情","enablePullDownRefresh":false,"navigationStyle":"custom","titleNView":false})
      },
      [
        createElement('pages-mes-wagedetails-wagedetails', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-mes-wagedetails-wagedetails',
  isNVue:false,maxWidth:0,
  pagePath:'pages/mes/wagedetails/wagedetails',
  windowTop:0
}
},
{
path: '/pages/mes/scanReport/scanReport',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"小组工资","enablePullDownRefresh":false,"navigationStyle":"custom","titleNView":false})
      },
      [
        createElement('pages-mes-scanReport-scanReport', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-mes-scanReport-scanReport',
  isNVue:false,maxWidth:0,
  pagePath:'pages/mes/scanReport/scanReport',
  windowTop:0
}
},
{
path: '/pages/mes/handindex/handindex',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"手动报工","enablePullDownRefresh":false,"navigationStyle":"custom","titleNView":false})
      },
      [
        createElement('pages-mes-handindex-handindex', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-mes-handindex-handindex',
  isNVue:false,maxWidth:0,
  pagePath:'pages/mes/handindex/handindex',
  windowTop:0
}
},
{
path: '/pages/mes/handindex/handdetail/handdetail',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"手动报工详情","enablePullDownRefresh":false,"navigationStyle":"custom","titleNView":false})
      },
      [
        createElement('pages-mes-handindex-handdetail-handdetail', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-mes-handindex-handdetail-handdetail',
  isNVue:false,maxWidth:0,
  pagePath:'pages/mes/handindex/handdetail/handdetail',
  windowTop:0
}
},
{
path: '/pages/mes/scanPage/scanPage',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"扫菲报工","enablePullDownRefresh":false,"navigationStyle":"custom","titleNView":false})
      },
      [
        createElement('pages-mes-scanPage-scanPage', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-mes-scanPage-scanPage',
  isNVue:false,maxWidth:0,
  pagePath:'pages/mes/scanPage/scanPage',
  windowTop:0
}
},
{
path: '/pages/mes/wagedetails/stylewage/stylewage',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"工资详情","enablePullDownRefresh":false,"navigationStyle":"custom","titleNView":false})
      },
      [
        createElement('pages-mes-wagedetails-stylewage-stylewage', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-mes-wagedetails-stylewage-stylewage',
  isNVue:false,maxWidth:0,
  pagePath:'pages/mes/wagedetails/stylewage/stylewage',
  windowTop:0
}
},
{
path: '/pages/mes/scanPage/selectTicket/selectTicket',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"选择菲票","enablePullDownRefresh":true,"navigationStyle":"custom","titleNView":false})
      },
      [
        createElement('pages-mes-scanPage-selectTicket-selectTicket', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-mes-scanPage-selectTicket-selectTicket',
  isNVue:false,maxWidth:0,
  pagePath:'pages/mes/scanPage/selectTicket/selectTicket',
  windowTop:0
}
},
{
path: '/pages/mes/cuttingbed/cuttingbed',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"裁床管理","enablePullDownRefresh":true,"navigationStyle":"custom","titleNView":false})
      },
      [
        createElement('pages-mes-cuttingbed-cuttingbed', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-mes-cuttingbed-cuttingbed',
  isNVue:false,maxWidth:0,
  pagePath:'pages/mes/cuttingbed/cuttingbed',
  windowTop:0
}
},
{
path: '/pages/mes/cuttingbed/reportdetails/reportdetails',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"汇报详情","enablePullDownRefresh":false,"navigationStyle":"custom","titleNView":false})
      },
      [
        createElement('pages-mes-cuttingbed-reportdetails-reportdetails', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-mes-cuttingbed-reportdetails-reportdetails',
  isNVue:false,maxWidth:0,
  pagePath:'pages/mes/cuttingbed/reportdetails/reportdetails',
  windowTop:0
}
},
{
path: '/pages/mes/packingList/packingList',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"裁片装箱","enablePullDownRefresh":true,"navigationStyle":"custom","titleNView":false})
      },
      [
        createElement('pages-mes-packingList-packingList', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-mes-packingList-packingList',
  isNVue:false,maxWidth:0,
  pagePath:'pages/mes/packingList/packingList',
  windowTop:0
}
},
{
path: '/pages/mes/packingList/packingListDetail/packingListDetail',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"装箱详情","enablePullDownRefresh":false,"navigationStyle":"custom","titleNView":false})
      },
      [
        createElement('pages-mes-packingList-packingListDetail-packingListDetail', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-mes-packingList-packingListDetail-packingListDetail',
  isNVue:false,maxWidth:0,
  pagePath:'pages/mes/packingList/packingListDetail/packingListDetail',
  windowTop:0
}
},
{
path: '/pages/mes/report/reportDelect/reportDelect',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"汇报删除记录","enablePullDownRefresh":false,"navigationStyle":"custom","titleNView":false})
      },
      [
        createElement('pages-mes-report-reportDelect-reportDelect', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-mes-report-reportDelect-reportDelect',
  isNVue:false,maxWidth:0,
  pagePath:'pages/mes/report/reportDelect/reportDelect',
  windowTop:0
}
},
{
path: '/pages/mes/wagedetails/stylewage/processwage/processwage',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"工序工资详情","enablePullDownRefresh":false,"navigationStyle":"custom","titleNView":false})
      },
      [
        createElement('pages-mes-wagedetails-stylewage-processwage-processwage', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-mes-wagedetails-stylewage-processwage-processwage',
  isNVue:false,maxWidth:0,
  pagePath:'pages/mes/wagedetails/stylewage/processwage/processwage',
  windowTop:0
}
},
{
path: '/pages/base/supplier/supplier',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"供应商管理","enablePullDownRefresh":true,"navigationStyle":"custom","titleNView":false})
      },
      [
        createElement('pages-base-supplier-supplier', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-base-supplier-supplier',
  isNVue:false,maxWidth:0,
  pagePath:'pages/base/supplier/supplier',
  windowTop:0
}
},
{
path: '/pages/base/supplier/supplierDetails/supplierDetails',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"供应商详情","enablePullDownRefresh":false,"navigationStyle":"custom","titleNView":false})
      },
      [
        createElement('pages-base-supplier-supplierDetails-supplierDetails', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-base-supplier-supplierDetails-supplierDetails',
  isNVue:false,maxWidth:0,
  pagePath:'pages/base/supplier/supplierDetails/supplierDetails',
  windowTop:0
}
},
{
path: '/pages/base/clientele/clientele',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"客户管理","enablePullDownRefresh":true,"navigationStyle":"custom","titleNView":false})
      },
      [
        createElement('pages-base-clientele-clientele', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-base-clientele-clientele',
  isNVue:false,maxWidth:0,
  pagePath:'pages/base/clientele/clientele',
  windowTop:0
}
},
{
path: '/pages/base/clientele/clienteleDetails/clienteleDetails',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"客户详情","enablePullDownRefresh":false,"navigationStyle":"custom","titleNView":false})
      },
      [
        createElement('pages-base-clientele-clienteleDetails-clienteleDetails', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-base-clientele-clienteleDetails-clienteleDetails',
  isNVue:false,maxWidth:0,
  pagePath:'pages/base/clientele/clienteleDetails/clienteleDetails',
  windowTop:0
}
},
{
path: '/pages/mes/outsource/outsourceDetail/outsourceDetail',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"外发详情","enablePullDownRefresh":false,"navigationStyle":"custom","titleNView":false})
      },
      [
        createElement('pages-mes-outsource-outsourceDetail-outsourceDetail', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-mes-outsource-outsourceDetail-outsourceDetail',
  isNVue:false,maxWidth:0,
  pagePath:'pages/mes/outsource/outsourceDetail/outsourceDetail',
  windowTop:0
}
},
{
path: '/pages/mes/outsource/outsource',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"外发管理","enablePullDownRefresh":true,"navigationStyle":"custom","titleNView":false})
      },
      [
        createElement('pages-mes-outsource-outsource', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-mes-outsource-outsource',
  isNVue:false,maxWidth:0,
  pagePath:'pages/mes/outsource/outsource',
  windowTop:0
}
},
{
path: '/pages/mes/addOutsource/addOutsource',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"新增外发","enablePullDownRefresh":false,"navigationStyle":"custom","titleNView":false})
      },
      [
        createElement('pages-mes-addOutsource-addOutsource', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-mes-addOutsource-addOutsource',
  isNVue:false,maxWidth:0,
  pagePath:'pages/mes/addOutsource/addOutsource',
  windowTop:0
}
},
{
path: '/pages/mes/addOutsource/selsectOrder/selsectOrder',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"选择生产单","enablePullDownRefresh":false,"navigationStyle":"custom","titleNView":false})
      },
      [
        createElement('pages-mes-addOutsource-selsectOrder-selsectOrder', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-mes-addOutsource-selsectOrder-selsectOrder',
  isNVue:false,maxWidth:0,
  pagePath:'pages/mes/addOutsource/selsectOrder/selsectOrder',
  windowTop:0
}
},
{
path: '/pages/mes/qualityRestriction/qualityRestriction',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"品质检验","enablePullDownRefresh":true,"navigationStyle":"custom","titleNView":false})
      },
      [
        createElement('pages-mes-qualityRestriction-qualityRestriction', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-mes-qualityRestriction-qualityRestriction',
  isNVue:false,maxWidth:0,
  pagePath:'pages/mes/qualityRestriction/qualityRestriction',
  windowTop:0
}
},
{
path: '/pages/mes/qualityRestriction/qualityDetails/qualityDetails',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"任务详情","enablePullDownRefresh":false,"navigationStyle":"custom","titleNView":false})
      },
      [
        createElement('pages-mes-qualityRestriction-qualityDetails-qualityDetails', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-mes-qualityRestriction-qualityDetails-qualityDetails',
  isNVue:false,maxWidth:0,
  pagePath:'pages/mes/qualityRestriction/qualityDetails/qualityDetails',
  windowTop:0
}
},
{
path: '/pages/mes/qualityRestriction/checkProgress/checkProgress',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"检验记录","enablePullDownRefresh":false,"navigationStyle":"custom","titleNView":false})
      },
      [
        createElement('pages-mes-qualityRestriction-checkProgress-checkProgress', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-mes-qualityRestriction-checkProgress-checkProgress',
  isNVue:false,maxWidth:0,
  pagePath:'pages/mes/qualityRestriction/checkProgress/checkProgress',
  windowTop:0
}
},
{
path: '/pages/mes/qualityRestriction/goCheck/goCheck',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"检验标准","enablePullDownRefresh":false,"navigationStyle":"custom","titleNView":false})
      },
      [
        createElement('pages-mes-qualityRestriction-goCheck-goCheck', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-mes-qualityRestriction-goCheck-goCheck',
  isNVue:false,maxWidth:0,
  pagePath:'pages/mes/qualityRestriction/goCheck/goCheck',
  windowTop:0
}
},
{
path: '/pages/mes/qualityRestriction/qualityReport/qualityReport',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"检验报告","enablePullDownRefresh":false,"navigationStyle":"custom","titleNView":false})
      },
      [
        createElement('pages-mes-qualityRestriction-qualityReport-qualityReport', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-mes-qualityRestriction-qualityReport-qualityReport',
  isNVue:false,maxWidth:0,
  pagePath:'pages/mes/qualityRestriction/qualityReport/qualityReport',
  windowTop:0
}
},
{
path: '/pages/base/mapDepot/mapDepot',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"图片素材库","enablePullDownRefresh":true,"navigationStyle":"custom","titleNView":false})
      },
      [
        createElement('pages-base-mapDepot-mapDepot', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-base-mapDepot-mapDepot',
  isNVue:false,maxWidth:0,
  pagePath:'pages/base/mapDepot/mapDepot',
  windowTop:0
}
},
{
path: '/pages/base/mapDepot/mapDepotDetails/mapDepotDetails',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"图片详情","enablePullDownRefresh":false,"navigationStyle":"custom","titleNView":false})
      },
      [
        createElement('pages-base-mapDepot-mapDepotDetails-mapDepotDetails', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-base-mapDepot-mapDepotDetails-mapDepotDetails',
  isNVue:false,maxWidth:0,
  pagePath:'pages/base/mapDepot/mapDepotDetails/mapDepotDetails',
  windowTop:0
}
},
{
path: '/pages/pdm/index/index',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"","enablePullDownRefresh":false})
      },
      [
        createElement('pages-pdm-index-index', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-pdm-index-index',
  isNVue:false,maxWidth:0,
  pagePath:'pages/pdm/index/index',
  windowTop:44
}
},
{
path: '/pages/mes/pullCloth/pullCloth',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"拉布单","enablePullDownRefresh":true,"navigationStyle":"custom","titleNView":false})
      },
      [
        createElement('pages-mes-pullCloth-pullCloth', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-mes-pullCloth-pullCloth',
  isNVue:false,maxWidth:0,
  pagePath:'pages/mes/pullCloth/pullCloth',
  windowTop:0
}
},
{
path: '/pages/mes/pullCloth/addPullcloth/addPullcloth',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"新增拉布","enablePullDownRefresh":false,"navigationStyle":"custom","titleNView":false})
      },
      [
        createElement('pages-mes-pullCloth-addPullcloth-addPullcloth', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-mes-pullCloth-addPullcloth-addPullcloth',
  isNVue:false,maxWidth:0,
  pagePath:'pages/mes/pullCloth/addPullcloth/addPullcloth',
  windowTop:0
}
},
{
path: '/pages/mes/pullCloth/selsectCloth/selsectCloth',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"导入物料","enablePullDownRefresh":false,"navigationStyle":"custom","titleNView":false})
      },
      [
        createElement('pages-mes-pullCloth-selsectCloth-selsectCloth', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-mes-pullCloth-selsectCloth-selsectCloth',
  isNVue:false,maxWidth:0,
  pagePath:'pages/mes/pullCloth/selsectCloth/selsectCloth',
  windowTop:0
}
},
{
path: '/pages/mes/loosenCloth/loosenCloth',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"松布单","enablePullDownRefresh":true,"navigationStyle":"custom","titleNView":false})
      },
      [
        createElement('pages-mes-loosenCloth-loosenCloth', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-mes-loosenCloth-loosenCloth',
  isNVue:false,maxWidth:0,
  pagePath:'pages/mes/loosenCloth/loosenCloth',
  windowTop:0
}
},
{
path: '/pages/mes/loosenCloth/addLoosencloth/addLoosencloth',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"新增松布","enablePullDownRefresh":false,"navigationStyle":"custom","titleNView":false})
      },
      [
        createElement('pages-mes-loosenCloth-addLoosencloth-addLoosencloth', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-mes-loosenCloth-addLoosencloth-addLoosencloth',
  isNVue:false,maxWidth:0,
  pagePath:'pages/mes/loosenCloth/addLoosencloth/addLoosencloth',
  windowTop:0
}
},
{
path: '/pages/mes/loosenCloth/loosenClothWidth/loosenClothWidth',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"松布幅宽","enablePullDownRefresh":false,"navigationStyle":"custom","titleNView":false})
      },
      [
        createElement('pages-mes-loosenCloth-loosenClothWidth-loosenClothWidth', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-mes-loosenCloth-loosenClothWidth-loosenClothWidth',
  isNVue:false,maxWidth:0,
  pagePath:'pages/mes/loosenCloth/loosenClothWidth/loosenClothWidth',
  windowTop:0
}
},
{
path: '/pages/mes/materialRequisition/materialRequisition',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"领料","enablePullDownRefresh":true,"navigationStyle":"custom","titleNView":false})
      },
      [
        createElement('pages-mes-materialRequisition-materialRequisition', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-mes-materialRequisition-materialRequisition',
  isNVue:false,maxWidth:0,
  pagePath:'pages/mes/materialRequisition/materialRequisition',
  windowTop:0
}
},
{
path: '/pages/mes/materialRequisition/addMaterialRequisition/addMaterialRequisition',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"新增领料","enablePullDownRefresh":false,"navigationStyle":"custom","titleNView":false})
      },
      [
        createElement('pages-mes-materialRequisition-addMaterialRequisition-addMaterialRequisition', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-mes-materialRequisition-addMaterialRequisition-addMaterialRequisition',
  isNVue:false,maxWidth:0,
  pagePath:'pages/mes/materialRequisition/addMaterialRequisition/addMaterialRequisition',
  windowTop:0
}
},
{
path: '/pages/mes/materialRequisition/importMaterialNeed/importMaterialNeed',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"导入物料需求","enablePullDownRefresh":false,"navigationStyle":"custom","titleNView":false})
      },
      [
        createElement('pages-mes-materialRequisition-importMaterialNeed-importMaterialNeed', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-mes-materialRequisition-importMaterialNeed-importMaterialNeed',
  isNVue:false,maxWidth:0,
  pagePath:'pages/mes/materialRequisition/importMaterialNeed/importMaterialNeed',
  windowTop:0
}
},
{
path: '/pages/mes/loosenCloth/importClothNeed/importClothNeed',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"导入物料","enablePullDownRefresh":false,"navigationStyle":"custom","titleNView":false})
      },
      [
        createElement('pages-mes-loosenCloth-importClothNeed-importClothNeed', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-mes-loosenCloth-importClothNeed-importClothNeed',
  isNVue:false,maxWidth:0,
  pagePath:'pages/mes/loosenCloth/importClothNeed/importClothNeed',
  windowTop:0
}
},
{
path: '/pages/mes/QC/QC',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"品检","enablePullDownRefresh":false,"navigationStyle":"custom","titleNView":false})
      },
      [
        createElement('pages-mes-QC-QC', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-mes-QC-QC',
  isNVue:false,maxWidth:0,
  pagePath:'pages/mes/QC/QC',
  windowTop:0
}
},
{
path: '/pages/mes/QC/QCdetails/QCdetails',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"品检详情","enablePullDownRefresh":false,"navigationStyle":"custom","titleNView":false})
      },
      [
        createElement('pages-mes-QC-QCdetails-QCdetails', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-mes-QC-QCdetails-QCdetails',
  isNVue:false,maxWidth:0,
  pagePath:'pages/mes/QC/QCdetails/QCdetails',
  windowTop:0
}
},
{
path: '/pages/mes/warehouse/comeWarehouse/comeWarehouse',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"","enablePullDownRefresh":false})
      },
      [
        createElement('pages-mes-warehouse-comeWarehouse-comeWarehouse', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-mes-warehouse-comeWarehouse-comeWarehouse',
  isNVue:false,maxWidth:0,
  pagePath:'pages/mes/warehouse/comeWarehouse/comeWarehouse',
  windowTop:44
}
},
{
path: '/pages/mes/warehouse/outWarehouse/outWarehouse',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"","enablePullDownRefresh":false})
      },
      [
        createElement('pages-mes-warehouse-outWarehouse-outWarehouse', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-mes-warehouse-outWarehouse-outWarehouse',
  isNVue:false,maxWidth:0,
  pagePath:'pages/mes/warehouse/outWarehouse/outWarehouse',
  windowTop:44
}
},
{
path: '/pages/mes/progressPage/progressPage',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"制单进度","enablePullDownRefresh":true,"navigationStyle":"custom","titleNView":false})
      },
      [
        createElement('pages-mes-progressPage-progressPage', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-mes-progressPage-progressPage',
  isNVue:false,maxWidth:0,
  pagePath:'pages/mes/progressPage/progressPage',
  windowTop:0
}
},
{
path: '/pages/mes/progressPage/progressDetails/progressDetails',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"制单进度详情","enablePullDownRefresh":true,"navigationStyle":"custom","titleNView":false})
      },
      [
        createElement('pages-mes-progressPage-progressDetails-progressDetails', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-mes-progressPage-progressDetails-progressDetails',
  isNVue:false,maxWidth:0,
  pagePath:'pages/mes/progressPage/progressDetails/progressDetails',
  windowTop:0
}
},
{
path: '/pages/mes/progressPage/progressList/progressList',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"节点汇报详情","enablePullDownRefresh":true,"navigationStyle":"custom","titleNView":false})
      },
      [
        createElement('pages-mes-progressPage-progressList-progressList', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-mes-progressPage-progressList-progressList',
  isNVue:false,maxWidth:0,
  pagePath:'pages/mes/progressPage/progressList/progressList',
  windowTop:0
}
},
{
path: '/pages/pdm/auditList/auditList',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"审核列表","enablePullDownRefresh":true,"navigationStyle":"custom","titleNView":false})
      },
      [
        createElement('pages-pdm-auditList-auditList', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-pdm-auditList-auditList',
  isNVue:false,maxWidth:0,
  pagePath:'pages/pdm/auditList/auditList',
  windowTop:0
}
},
{
path: '/pages/pdm/sampleManagement/sampleList/sampleList',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"样衣管理","enablePullDownRefresh":true,"navigationStyle":"custom","titleNView":false})
      },
      [
        createElement('pages-pdm-sampleManagement-sampleList-sampleList', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-pdm-sampleManagement-sampleList-sampleList',
  isNVue:false,maxWidth:0,
  pagePath:'pages/pdm/sampleManagement/sampleList/sampleList',
  windowTop:0
}
},
{
path: '/pages/pdm/sampleManagement/sampleSale/sampleSale',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"样衣销售","enablePullDownRefresh":false})
      },
      [
        createElement('pages-pdm-sampleManagement-sampleSale-sampleSale', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-pdm-sampleManagement-sampleSale-sampleSale',
  isNVue:false,maxWidth:0,
  pagePath:'pages/pdm/sampleManagement/sampleSale/sampleSale',
  windowTop:44
}
},
{
path: '/pages/pdm/sampleManagement/sampleInventory/sampleInventory',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"样衣盘点","enablePullDownRefresh":false})
      },
      [
        createElement('pages-pdm-sampleManagement-sampleInventory-sampleInventory', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-pdm-sampleManagement-sampleInventory-sampleInventory',
  isNVue:false,maxWidth:0,
  pagePath:'pages/pdm/sampleManagement/sampleInventory/sampleInventory',
  windowTop:44
}
},
{
path: '/pages/pdm/sampleManagement/sampleBorrow/sampleBorrow',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"借样","enablePullDownRefresh":false})
      },
      [
        createElement('pages-pdm-sampleManagement-sampleBorrow-sampleBorrow', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-pdm-sampleManagement-sampleBorrow-sampleBorrow',
  isNVue:false,maxWidth:0,
  pagePath:'pages/pdm/sampleManagement/sampleBorrow/sampleBorrow',
  windowTop:44
}
},
{
path: '/pages/pdm/sampleManagement/sampleAlso/sampleAlso',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"还样","enablePullDownRefresh":false})
      },
      [
        createElement('pages-pdm-sampleManagement-sampleAlso-sampleAlso', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-pdm-sampleManagement-sampleAlso-sampleAlso',
  isNVue:false,maxWidth:0,
  pagePath:'pages/pdm/sampleManagement/sampleAlso/sampleAlso',
  windowTop:44
}
},
{
path: '/pages/scm/fullLifeCircle/fullLifeCircle',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"订单进度跟踪","enablePullDownRefresh":true,"navigationStyle":"custom","titleNView":false})
      },
      [
        createElement('pages-scm-fullLifeCircle-fullLifeCircle', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-scm-fullLifeCircle-fullLifeCircle',
  isNVue:false,maxWidth:0,
  pagePath:'pages/scm/fullLifeCircle/fullLifeCircle',
  windowTop:0
}
},
{
path: '/pages/scm/fullLifeCircle/fullLifeCircleDetails/fullLifeCircleDetails',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"订单进度跟踪详情","enablePullDownRefresh":true,"navigationStyle":"custom","titleNView":false})
      },
      [
        createElement('pages-scm-fullLifeCircle-fullLifeCircleDetails-fullLifeCircleDetails', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-scm-fullLifeCircle-fullLifeCircleDetails-fullLifeCircleDetails',
  isNVue:false,maxWidth:0,
  pagePath:'pages/scm/fullLifeCircle/fullLifeCircleDetails/fullLifeCircleDetails',
  windowTop:0
}
},
{
path: '/pages/scm/fullLifeCircle/fullLifeCircleDetails/components/cutNumberReport',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"订单进度跟踪详情","enablePullDownRefresh":true,"navigationStyle":"custom","titleNView":false})
      },
      [
        createElement('pages-scm-fullLifeCircle-fullLifeCircleDetails-components-cutNumberReport', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-scm-fullLifeCircle-fullLifeCircleDetails-components-cutNumberReport',
  isNVue:false,maxWidth:0,
  pagePath:'pages/scm/fullLifeCircle/fullLifeCircleDetails/components/cutNumberReport',
  windowTop:0
}
},
{
path: '/pages/scm/fullLifeCircle/fullLifeCircleDetails/components/editFullLifeCircleDetails',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"订单进度跟踪详情","enablePullDownRefresh":true,"navigationStyle":"custom","titleNView":false})
      },
      [
        createElement('pages-scm-fullLifeCircle-fullLifeCircleDetails-components-editFullLifeCircleDetails', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-scm-fullLifeCircle-fullLifeCircleDetails-components-editFullLifeCircleDetails',
  isNVue:false,maxWidth:0,
  pagePath:'pages/scm/fullLifeCircle/fullLifeCircleDetails/components/editFullLifeCircleDetails',
  windowTop:0
}
},
{
path: '/pages/wms/purchase/purchaseList',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"采购申请单列表","enablePullDownRefresh":true,"navigationStyle":"custom","titleNView":false})
      },
      [
        createElement('pages-wms-purchase-purchaseList', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-wms-purchase-purchaseList',
  isNVue:false,maxWidth:0,
  pagePath:'pages/wms/purchase/purchaseList',
  windowTop:0
}
},
{
path: '/pages/wms/purchase/addPurchase',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"采购申请单","enablePullDownRefresh":true,"navigationStyle":"custom","titleNView":false})
      },
      [
        createElement('pages-wms-purchase-addPurchase', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-wms-purchase-addPurchase',
  isNVue:false,maxWidth:0,
  pagePath:'pages/wms/purchase/addPurchase',
  windowTop:0
}
},
{
path: '/pages/wms/components/addMaterial',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"导入物料信息","enablePullDownRefresh":true,"navigationStyle":"custom","titleNView":false})
      },
      [
        createElement('pages-wms-components-addMaterial', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-wms-components-addMaterial',
  isNVue:false,maxWidth:0,
  pagePath:'pages/wms/components/addMaterial',
  windowTop:0
}
},
{
path: '/pages/wms/purchase/editPurchaseMaterial',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"采购申请单物料编辑","enablePullDownRefresh":true,"navigationStyle":"custom","titleNView":false})
      },
      [
        createElement('pages-wms-purchase-editPurchaseMaterial', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-wms-purchase-editPurchaseMaterial',
  isNVue:false,maxWidth:0,
  pagePath:'pages/wms/purchase/editPurchaseMaterial',
  windowTop:0
}
},
{
path: '/pages/wms/purchase/purchaseDetails',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"采购申请单详情","enablePullDownRefresh":true,"navigationStyle":"custom","titleNView":false})
      },
      [
        createElement('pages-wms-purchase-purchaseDetails', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-wms-purchase-purchaseDetails',
  isNVue:false,maxWidth:0,
  pagePath:'pages/wms/purchase/purchaseDetails',
  windowTop:0
}
},
{
path: '/pages/wms/purchase/purchaseMaterialDetails',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"物料详情","enablePullDownRefresh":true,"navigationStyle":"custom","titleNView":false})
      },
      [
        createElement('pages-wms-purchase-purchaseMaterialDetails', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-wms-purchase-purchaseMaterialDetails',
  isNVue:false,maxWidth:0,
  pagePath:'pages/wms/purchase/purchaseMaterialDetails',
  windowTop:0
}
},
{
path: '/pages/wms/mergePurchase/mergePurchaseList',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"合并采购","enablePullDownRefresh":true,"navigationStyle":"custom","titleNView":false})
      },
      [
        createElement('pages-wms-mergePurchase-mergePurchaseList', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-wms-mergePurchase-mergePurchaseList',
  isNVue:false,maxWidth:0,
  pagePath:'pages/wms/mergePurchase/mergePurchaseList',
  windowTop:0
}
},
{
path: '/pages/wms/mergePurchase/mergePurchase',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"合并采购单","enablePullDownRefresh":false,"navigationStyle":"custom","titleNView":false})
      },
      [
        createElement('pages-wms-mergePurchase-mergePurchase', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-wms-mergePurchase-mergePurchase',
  isNVue:false,maxWidth:0,
  pagePath:'pages/wms/mergePurchase/mergePurchase',
  windowTop:0
}
},
{
path: '/pages/wms/components/editSupplier',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"供应商信息","enablePullDownRefresh":true,"navigationStyle":"custom","titleNView":false})
      },
      [
        createElement('pages-wms-components-editSupplier', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-wms-components-editSupplier',
  isNVue:false,maxWidth:0,
  pagePath:'pages/wms/components/editSupplier',
  windowTop:0
}
},
{
path: '/pages/wms/purorder/purorderList',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"采购单","enablePullDownRefresh":true,"navigationStyle":"custom","titleNView":false})
      },
      [
        createElement('pages-wms-purorder-purorderList', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-wms-purorder-purorderList',
  isNVue:false,maxWidth:0,
  pagePath:'pages/wms/purorder/purorderList',
  windowTop:0
}
},
{
path: '/pages/wms/purorder/addPurorder',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"新增采购单","enablePullDownRefresh":true,"navigationStyle":"custom","titleNView":false})
      },
      [
        createElement('pages-wms-purorder-addPurorder', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-wms-purorder-addPurorder',
  isNVue:false,maxWidth:0,
  pagePath:'pages/wms/purorder/addPurorder',
  windowTop:0
}
},
{
path: '/pages/wms/purorder/purorderDetails',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"采购单详情","enablePullDownRefresh":true,"navigationStyle":"custom","titleNView":false})
      },
      [
        createElement('pages-wms-purorder-purorderDetails', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-wms-purorder-purorderDetails',
  isNVue:false,maxWidth:0,
  pagePath:'pages/wms/purorder/purorderDetails',
  windowTop:0
}
},
{
path: '/pages/wms/purorder/editPurorderDetails',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"编辑采购单详情","enablePullDownRefresh":true,"navigationStyle":"custom","titleNView":false})
      },
      [
        createElement('pages-wms-purorder-editPurorderDetails', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-wms-purorder-editPurorderDetails',
  isNVue:false,maxWidth:0,
  pagePath:'pages/wms/purorder/editPurorderDetails',
  windowTop:0
}
},
{
path: '/pages/wms/purorder/purorderMaterialDetails',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"物料详情","enablePullDownRefresh":true,"navigationStyle":"custom","titleNView":false})
      },
      [
        createElement('pages-wms-purorder-purorderMaterialDetails', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-wms-purorder-purorderMaterialDetails',
  isNVue:false,maxWidth:0,
  pagePath:'pages/wms/purorder/purorderMaterialDetails',
  windowTop:0
}
},
{
path: '/pages/wms/orderDeliverySchedule/orderDeliveryScheduleList',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"订单交货计划","enablePullDownRefresh":true,"navigationStyle":"custom","titleNView":false})
      },
      [
        createElement('pages-wms-orderDeliverySchedule-orderDeliveryScheduleList', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-wms-orderDeliverySchedule-orderDeliveryScheduleList',
  isNVue:false,maxWidth:0,
  pagePath:'pages/wms/orderDeliverySchedule/orderDeliveryScheduleList',
  windowTop:0
}
},
{
path: '/pages/wms/orderDeliverySchedule/components/purchasingList',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"采购单信息","enablePullDownRefresh":true,"navigationStyle":"custom","titleNView":false})
      },
      [
        createElement('pages-wms-orderDeliverySchedule-components-purchasingList', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-wms-orderDeliverySchedule-components-purchasingList',
  isNVue:false,maxWidth:0,
  pagePath:'pages/wms/orderDeliverySchedule/components/purchasingList',
  windowTop:0
}
},
{
path: '/pages/wms/orderDeliverySchedule/addOrderDeliverySchedule',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"新增交货计划","enablePullDownRefresh":true,"navigationStyle":"custom","titleNView":false})
      },
      [
        createElement('pages-wms-orderDeliverySchedule-addOrderDeliverySchedule', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-wms-orderDeliverySchedule-addOrderDeliverySchedule',
  isNVue:false,maxWidth:0,
  pagePath:'pages/wms/orderDeliverySchedule/addOrderDeliverySchedule',
  windowTop:0
}
},
{
path: '/pages/wms/orderDeliverySchedule/orderDeliveryScheduleDetails',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"交货计划详情","enablePullDownRefresh":true,"navigationStyle":"custom","titleNView":false})
      },
      [
        createElement('pages-wms-orderDeliverySchedule-orderDeliveryScheduleDetails', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-wms-orderDeliverySchedule-orderDeliveryScheduleDetails',
  isNVue:false,maxWidth:0,
  pagePath:'pages/wms/orderDeliverySchedule/orderDeliveryScheduleDetails',
  windowTop:0
}
},
{
path: '/pages/wms/orderDeliverySchedule/orderDeliveryScheduleMaterialDetails',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"物料详情","enablePullDownRefresh":true,"navigationStyle":"custom","titleNView":false})
      },
      [
        createElement('pages-wms-orderDeliverySchedule-orderDeliveryScheduleMaterialDetails', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-wms-orderDeliverySchedule-orderDeliveryScheduleMaterialDetails',
  isNVue:false,maxWidth:0,
  pagePath:'pages/wms/orderDeliverySchedule/orderDeliveryScheduleMaterialDetails',
  windowTop:0
}
},
{
path: '/pages/wms/orderDeliverySchedule/editOrderDeliveryScheduleMaterialDetails',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"编辑物料详情","enablePullDownRefresh":true,"navigationStyle":"custom","titleNView":false})
      },
      [
        createElement('pages-wms-orderDeliverySchedule-editOrderDeliveryScheduleMaterialDetails', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-wms-orderDeliverySchedule-editOrderDeliveryScheduleMaterialDetails',
  isNVue:false,maxWidth:0,
  pagePath:'pages/wms/orderDeliverySchedule/editOrderDeliveryScheduleMaterialDetails',
  windowTop:0
}
},
{
path: '/pages/wms/iqc/checkList/finishProduct',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"品检登记-成品","enablePullDownRefresh":true,"navigationStyle":"custom","titleNView":false})
      },
      [
        createElement('pages-wms-iqc-checkList-finishProduct', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-wms-iqc-checkList-finishProduct',
  isNVue:false,maxWidth:0,
  pagePath:'pages/wms/iqc/checkList/finishProduct',
  windowTop:0
}
},
{
path: '/pages/wms/iqc/checkList/finishProductDetail',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"质检详情","enablePullDownRefresh":true,"navigationStyle":"custom","titleNView":false})
      },
      [
        createElement('pages-wms-iqc-checkList-finishProductDetail', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-wms-iqc-checkList-finishProductDetail',
  isNVue:false,maxWidth:0,
  pagePath:'pages/wms/iqc/checkList/finishProductDetail',
  windowTop:0
}
},
{
path: '/pages/wms/iqc/checkList/material',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"品检登记-物料","enablePullDownRefresh":true,"navigationStyle":"custom","titleNView":false})
      },
      [
        createElement('pages-wms-iqc-checkList-material', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-wms-iqc-checkList-material',
  isNVue:false,maxWidth:0,
  pagePath:'pages/wms/iqc/checkList/material',
  windowTop:0
}
},
{
path: '/pages/wms/iqc/checkList/materialDetail',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"质检详情","enablePullDownRefresh":false})
      },
      [
        createElement('pages-wms-iqc-checkList-materialDetail', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-wms-iqc-checkList-materialDetail',
  isNVue:false,maxWidth:0,
  pagePath:'pages/wms/iqc/checkList/materialDetail',
  windowTop:44
}
},
{
path: '/pages/mes/packing/packing/packing',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"包装报工","enablePullDownRefresh":false,"navigationStyle":"custom","titleNView":false})
      },
      [
        createElement('pages-mes-packing-packing-packing', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-mes-packing-packing-packing',
  isNVue:false,maxWidth:0,
  pagePath:'pages/mes/packing/packing/packing',
  windowTop:0
}
},
{
path: '/pages/mes/packing/packingDetails/packingDetails',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"包装报工详情","enablePullDownRefresh":false,"navigationStyle":"custom","titleNView":false})
      },
      [
        createElement('pages-mes-packing-packingDetails-packingDetails', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-mes-packing-packingDetails-packingDetails',
  isNVue:false,maxWidth:0,
  pagePath:'pages/mes/packing/packingDetails/packingDetails',
  windowTop:0
}
},
{
path: '/pages/mes/braCupPacking/braCupPackingList',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"模杯装箱","enablePullDownRefresh":true,"navigationStyle":"custom","titleNView":false})
      },
      [
        createElement('pages-mes-braCupPacking-braCupPackingList', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-mes-braCupPacking-braCupPackingList',
  isNVue:false,maxWidth:0,
  pagePath:'pages/mes/braCupPacking/braCupPackingList',
  windowTop:0
}
},
{
path: '/pages/mes/braCupPacking/braCupPackingDetail',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"模杯装箱详情","enablePullDownRefresh":false,"navigationStyle":"custom","titleNView":false})
      },
      [
        createElement('pages-mes-braCupPacking-braCupPackingDetail', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-mes-braCupPacking-braCupPackingDetail',
  isNVue:false,maxWidth:0,
  pagePath:'pages/mes/braCupPacking/braCupPackingDetail',
  windowTop:0
}
},
{
path: '/pages/check/checkList/checkList',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"审批管理","enablePullDownRefresh":true,"navigationStyle":"custom","titleNView":false})
      },
      [
        createElement('pages-check-checkList-checkList', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-check-checkList-checkList',
  isNVue:false,maxWidth:0,
  pagePath:'pages/check/checkList/checkList',
  windowTop:0
}
},
{
path: '/pages/check/checkList/paymentCheck/paymentCheck',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"待办详情","enablePullDownRefresh":false,"navigationStyle":"custom","titleNView":false})
      },
      [
        createElement('pages-check-checkList-paymentCheck-paymentCheck', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-check-checkList-paymentCheck-paymentCheck',
  isNVue:false,maxWidth:0,
  pagePath:'pages/check/checkList/paymentCheck/paymentCheck',
  windowTop:0
}
},
{
path: '/pages/check/checkList/paymentCheck/otherPayableOrder',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"付款单审核详情","enablePullDownRefresh":false,"navigationStyle":"custom","titleNView":false})
      },
      [
        createElement('pages-check-checkList-paymentCheck-otherPayableOrder', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-check-checkList-paymentCheck-otherPayableOrder',
  isNVue:false,maxWidth:0,
  pagePath:'pages/check/checkList/paymentCheck/otherPayableOrder',
  windowTop:0
}
},
{
path: '/pages/check/checkList/outsourceCheck/outsourceCheck',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"委外订单审核详情","enablePullDownRefresh":false,"navigationStyle":"custom","titleNView":false})
      },
      [
        createElement('pages-check-checkList-outsourceCheck-outsourceCheck', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-check-checkList-outsourceCheck-outsourceCheck',
  isNVue:false,maxWidth:0,
  pagePath:'pages/check/checkList/outsourceCheck/outsourceCheck',
  windowTop:0
}
},
{
path: '/pages/check/checkList/pricingCheck/pricingCheck',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"核价单审核详情","enablePullDownRefresh":false,"navigationStyle":"custom","titleNView":false})
      },
      [
        createElement('pages-check-checkList-pricingCheck-pricingCheck', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-check-checkList-pricingCheck-pricingCheck',
  isNVue:false,maxWidth:0,
  pagePath:'pages/check/checkList/pricingCheck/pricingCheck',
  windowTop:0
}
},
{
path: '/pages/check/checkList/clientCheck/clientCheck',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"客户档案审核详情","enablePullDownRefresh":false,"navigationStyle":"custom","titleNView":false})
      },
      [
        createElement('pages-check-checkList-clientCheck-clientCheck', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-check-checkList-clientCheck-clientCheck',
  isNVue:false,maxWidth:0,
  pagePath:'pages/check/checkList/clientCheck/clientCheck',
  windowTop:0
}
},
{
path: '/pages/check/checkList/supplierCheck/supplierCheck',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"供应商审核详情","enablePullDownRefresh":false,"navigationStyle":"custom","titleNView":false})
      },
      [
        createElement('pages-check-checkList-supplierCheck-supplierCheck', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-check-checkList-supplierCheck-supplierCheck',
  isNVue:false,maxWidth:0,
  pagePath:'pages/check/checkList/supplierCheck/supplierCheck',
  windowTop:0
}
},
{
path: '/pages/check/checkList/purchaseCheck/purchaseCheck',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"采购单审核详情","enablePullDownRefresh":false,"navigationStyle":"custom","titleNView":false})
      },
      [
        createElement('pages-check-checkList-purchaseCheck-purchaseCheck', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-check-checkList-purchaseCheck-purchaseCheck',
  isNVue:false,maxWidth:0,
  pagePath:'pages/check/checkList/purchaseCheck/purchaseCheck',
  windowTop:0
}
},
{
path: '/pages/check/checkList/prepayCheck/prepayCheck',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"预付单审核详情","enablePullDownRefresh":false,"navigationStyle":"custom","titleNView":false})
      },
      [
        createElement('pages-check-checkList-prepayCheck-prepayCheck', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-check-checkList-prepayCheck-prepayCheck',
  isNVue:false,maxWidth:0,
  pagePath:'pages/check/checkList/prepayCheck/prepayCheck',
  windowTop:0
}
},
{
path: '/pages/check/checkList/prepayCheck/prepayDetail',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"预付单单据详情","enablePullDownRefresh":false,"navigationStyle":"custom","titleNView":false})
      },
      [
        createElement('pages-check-checkList-prepayCheck-prepayDetail', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-check-checkList-prepayCheck-prepayDetail',
  isNVue:false,maxWidth:0,
  pagePath:'pages/check/checkList/prepayCheck/prepayDetail',
  windowTop:0
}
},
{
path: '/pages/mes/groupCheck/groupCheck',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"组检","enablePullDownRefresh":false,"navigationStyle":"custom","titleNView":false})
      },
      [
        createElement('pages-mes-groupCheck-groupCheck', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-mes-groupCheck-groupCheck',
  isNVue:false,maxWidth:0,
  pagePath:'pages/mes/groupCheck/groupCheck',
  windowTop:0
}
},
{
path: '/pages/mes/endCheck/endCheck',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"尾检","enablePullDownRefresh":false,"navigationStyle":"custom","titleNView":false})
      },
      [
        createElement('pages-mes-endCheck-endCheck', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-mes-endCheck-endCheck',
  isNVue:false,maxWidth:0,
  pagePath:'pages/mes/endCheck/endCheck',
  windowTop:0
}
},
{
path: '/choose-location',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props:{
          navigationStyle:'custom'
        }
      },
      [
        createElement('system-choose-location', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'choose-location',
  pagePath:'/choose-location'
}
}
    ,
{
path: '/open-location',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props:{
          navigationStyle:'custom'
        }
      },
      [
        createElement('system-open-location', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'open-location',
  pagePath:'/open-location'
}
}
    ]
global.UniApp && new global.UniApp();
